/**
 * DevExtreme (ui/data_grid/ui.data_grid.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var _uiData_grid = require("./ui.data_grid.base");
var _uiData_grid2 = _interopRequireDefault(_uiData_grid);
require("./ui.data_grid.state_storing");
require("./ui.data_grid.selection");
require("./ui.data_grid.column_chooser");
require("./ui.data_grid.grouping");
require("./ui.data_grid.master_detail");
require("./ui.data_grid.editing");
require("./ui.data_grid.validating");
require("./ui.data_grid.virtual_scrolling");
require("./ui.data_grid.filter_row");
require("./ui.data_grid.header_filter");
require("./ui.data_grid.filter_sync");
require("./ui.data_grid.filter_builder");
require("./ui.data_grid.filter_panel");
require("./ui.data_grid.search");
require("./ui.data_grid.pager");
require("./ui.data_grid.columns_resizing_reordering");
require("./ui.data_grid.keyboard_navigation");
require("./ui.data_grid.summary");
require("./ui.data_grid.column_fixing");
require("./ui.data_grid.adaptivity");
require("./ui.data_grid.virtual_columns");
require("./ui.data_grid.export");
require("./ui.data_grid.focus");
require("./ui.data_grid.row_dragging");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    }
}
module.exports = _uiData_grid2.default;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/data_grid/ui.data_grid.js
// module id = 558
// module chunks = 0